import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import STRINGS from "../../Constants/Strings";
import { isValidEmail, isValidPhoneNumber } from "./utils";

export const EditContactModal = ({
  showContactEditModal,
  handleContactModalClose,
  account,
  applicant,
  handleContactSaveClick,
  formatPhoneNumber,
}) => {
  const [contactFormData, setContactFormData] = useState({
    email: applicant?.member?.email || account?.email || "",
    mobileNo:
      applicant?.address?.currentAddressCellPhoneArea +
        applicant?.address?.currentAddressCellPhone ||
      account?.msisdn ||
      "",
    homeNo:
      applicant?.address?.currentAddressPhoneArea +
      applicant?.address?.currentAddressPhone,
    otherNo:
      applicant?.contact?.alternateContactArea +
      applicant?.contact?.alternateContactPhone,
  });
  const [contactFormErrors, setContactFormErrors] = useState({
    email: "",
    mobileNo: "",
    homeNo: "",
    otherNo: "",
  });

  useEffect(() => {
    setContactFormData({
      email: applicant?.member?.email || account?.email || "",
      mobileNo:
        applicant?.address?.currentAddressCellPhoneArea +
          applicant?.address?.currentAddressCellPhone ||
        account?.msisdn ||
        "",
      homeNo:
        applicant?.address?.currentAddressPhoneArea +
        applicant?.address?.currentAddressPhone,
      otherNo:
        applicant?.contact?.alternateContactArea +
        applicant?.contact?.alternateContactPhone,
    });
  }, [account, applicant]);

  const handleContactInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNo" || name === "homeNo" || name === "otherNo") {
      let digitsOnly = value.replace(/\D/g, "");
      if (
        value.startsWith("+1") &&
        digitsOnly.startsWith("1") &&
        digitsOnly.length > 1
      ) {
        digitsOnly = digitsOnly.substring(1);
      }
      if (digitsOnly.length <= 10) {
        setContactFormData((prev) => ({
          ...prev,
          [name]: digitsOnly,
        }));
      }
    } else if (name === "email") {
      const validEmailChars = value.replace(/[^a-zA-Z0-9@._\-+]/g, "");
      setContactFormData((prev) => ({
        ...prev,
        [name]: validEmailChars,
      }));
    } else {
      setContactFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSave = () => {
    const errors = {
      email: "",
      mobileNo: "",
      homeNo: "",
      otherNo: "",
    };

    if (!contactFormData.email || contactFormData.email.trim() === "") {
      errors.email =
        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_CONTACT_DETAILS_MODAL.ERROR_EMAIL_REQUIRED;
    } else if (!isValidEmail(contactFormData.email)) {
      errors.email =
        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_CONTACT_DETAILS_MODAL.ERROR_EMAIL_INVALID;
    }

    if (!contactFormData.mobileNo || contactFormData.mobileNo.trim() === "") {
      errors.mobileNo =
        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_CONTACT_DETAILS_MODAL.ERROR_MOBILE_REQUIRED;
    } else if (!isValidPhoneNumber(contactFormData.mobileNo)) {
      errors.mobileNo =
        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_CONTACT_DETAILS_MODAL.ERROR_PHONE_INVALID;
    }

    if (contactFormData.homeNo && contactFormData.homeNo.trim() !== "") {
      if (!isValidPhoneNumber(contactFormData.homeNo)) {
        errors.homeNo =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_CONTACT_DETAILS_MODAL.ERROR_PHONE_INVALID;
      }
    }

    if (contactFormData.otherNo && contactFormData.otherNo.trim() !== "") {
      if (!isValidPhoneNumber(contactFormData.otherNo)) {
        errors.otherNo =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_CONTACT_DETAILS_MODAL.ERROR_PHONE_INVALID;
      }
    }

    setContactFormErrors(errors);

    const hasErrors = Object.values(errors).some((error) => error !== "");
    if (!hasErrors) {
      handleContactSaveClick(contactFormData);
      handleContactModalClose();
    }
  };

  return (
    <Modal
      show={showContactEditModal}
      onHide={handleContactModalClose}
      className="[ popup-modal__container ]"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="[ popup-modal__header ]" closeButton>
        <Modal.Title>
          {
            STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
              .EDIT_CONTACT_DETAILS_MODAL.TITLE
          }
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="[ row ]">
          <div className="[ col-12 ]">
            {/* Email */}
            <div className="[ mb-3 ]">
              <label htmlFor="email" className="[ form-label ]">
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_CONTACT_DETAILS_MODAL.EMAIL_LABEL
                }
              </label>
              <input
                id="email"
                type="email"
                name="email"
                className={`[ form-control ] ${
                  contactFormErrors.email ? "[ is-invalid ]" : ""
                }`}
                value={contactFormData.email}
                onChange={handleContactInputChange}
                placeholder={
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_CONTACT_DETAILS_MODAL.EMAIL_PLACEHOLDER
                }
              />
              {contactFormErrors.email && (
                <div className="[ invalid-feedback ]">
                  {contactFormErrors.email}
                </div>
              )}
            </div>

            {/* Mobile No */}
            <div className="[ mb-3 ]">
              <label htmlFor="mobileNo" className="[ form-label ]">
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_CONTACT_DETAILS_MODAL.MOBILE_LABEL
                }
              </label>
              <input
                id="mobileNo"
                type="tel"
                name="mobileNo"
                className={`[ form-control ] ${
                  contactFormErrors.mobileNo ? "[ is-invalid ]" : ""
                }`}
                value={formatPhoneNumber(contactFormData.mobileNo)}
                onChange={handleContactInputChange}
                placeholder={
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_CONTACT_DETAILS_MODAL.PHONE_PLACEHOLDER
                }
              />
              {contactFormErrors.mobileNo && (
                <div className="[ invalid-feedback ]">
                  {contactFormErrors.mobileNo}
                </div>
              )}
            </div>

            {/* Home No */}
            <div className="[ mb-3 ]">
              <label htmlFor="homeNo" className="[ form-label ]">
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_CONTACT_DETAILS_MODAL.HOME_LABEL
                }
              </label>
              <input
                id="homeNo"
                type="tel"
                name="homeNo"
                className={`[ form-control ] ${
                  contactFormErrors.homeNo ? "[ is-invalid ]" : ""
                }`}
                value={formatPhoneNumber(contactFormData.homeNo)}
                onChange={handleContactInputChange}
                placeholder={
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_CONTACT_DETAILS_MODAL.PHONE_PLACEHOLDER
                }
              />
              {contactFormErrors.homeNo && (
                <div className="[ invalid-feedback ]">
                  {contactFormErrors.homeNo}
                </div>
              )}
            </div>

            {/* Other No */}
            <div className="[ mb-3 ]">
              <label htmlFor="otherNo" className="[ form-label ]">
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_CONTACT_DETAILS_MODAL.OTHER_LABEL
                }
              </label>
              <input
                id="otherNo"
                type="tel"
                name="otherNo"
                className={`[ form-control ] ${
                  contactFormErrors.otherNo ? "[ is-invalid ]" : ""
                }`}
                value={formatPhoneNumber(contactFormData.otherNo)}
                onChange={handleContactInputChange}
                placeholder={
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_CONTACT_DETAILS_MODAL.PHONE_PLACEHOLDER
                }
              />
              {contactFormErrors.otherNo && (
                <div className="[ invalid-feedback ]">
                  {contactFormErrors.otherNo}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="[ divider ]"></div>
      </Modal.Body>

      <Modal.Footer className="[ popup-modal-footer ] [ d-block ]">
        <div className="[ mb-3 ]">
          <button
            type="button"
            className="[ submit-btn btn ] [ w-100 ]"
            onClick={handleSave}
            style={{ borderRadius: ".5em" }}
          >
            {
              STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                .EDIT_CONTACT_DETAILS_MODAL.SAVE_BUTTON
            }
          </button>
        </div>
        <div className="[ mb-3 text-center ]">
          <span
            className="[ link ]"
            onClick={handleContactModalClose}
            role="presentation"
            style={{
              textDecoration: "underline",
              color: "#0090c6",
              cursor: "pointer",
            }}
          >
            {
              STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                .EDIT_CONTACT_DETAILS_MODAL.CANCEL_BUTTON
            }
          </span>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
